import React from "react";
import { Award, Sparkles, Flag, MessageCircle, Trophy, Medal, Clock, Feather } from "lucide-react";

const ICONS = {
  sparkles: Sparkles,
  flag: Flag,
  "message-circle": MessageCircle,
  trophy: Trophy,
  medal: Medal,
  clock: Clock,
  feather: Feather,
};

// Local mirror of the backend BADGE_CATALOG
export const BADGE_CATALOG = {
  welcome: { label: "خوش آمدید", icon: "sparkles", color: "#01411C" },
  first_thread: { label: "پہلا موضوع", icon: "flag", color: "#D4AF37" },
  chatty: { label: "١٠ پیغامات", icon: "message-circle", color: "#4A6FA5" },
  half_century: { label: "٥٠ پیغامات", icon: "trophy", color: "#A5714A" },
  century: { label: "١٠٠ پیغامات", icon: "medal", color: "#B45309" },
  elder: { label: "پرانا رکن", icon: "clock", color: "#5A5A5A" },
  poet: { label: "شاعر", icon: "feather", color: "#7C3AED" },
};

export default function BadgesRow({ badges = [], size = "sm" }) {
  if (!badges || badges.length === 0) return null;
  const pad = size === "lg" ? "px-2.5 py-1 text-xs" : "px-1.5 py-0.5 text-[10px]";
  const iconSize = size === "lg" ? 12 : 10;
  return (
    <div className="flex items-center flex-wrap gap-1" data-testid="badges-row">
      {badges.map((b) => {
        const meta = BADGE_CATALOG[b];
        if (!meta) return null;
        const Ico = ICONS[meta.icon] || Award;
        return (
          <span
            key={b}
            title={meta.label}
            className={`inline-flex items-center gap-1 font-eng font-semibold rounded ${pad}`}
            style={{ background: `${meta.color}18`, color: meta.color, border: `1px solid ${meta.color}30` }}
          >
            <Ico size={iconSize} />
            <span className="urdu-naskh">{meta.label}</span>
          </span>
        );
      })}
    </div>
  );
}
